import { Injectable } from "@angular/core";
import { from } from "rxjs";
import { ServerType } from "./app-init.service";
import { RestApiService } from "./rest-api.service";

@Injectable({
  providedIn: "root",
})
export class StripeService {
  stripe;
  stripePublishableId =
    "pk_live_51IyeJdLDBqircwk8ppxBCFjA08GhEksqGDfymqcQnsYmaJ8I4px2nVssgxJJrYSOVpG6ojN3dzAzpBotiZ1j6qw700VD34boDp";

  constructor(private restApiService: RestApiService) {
    this.stripe = (<any>window).Stripe(this.stripePublishableId);
  }

  payWithCard(card, clientSecret) {
    return from(
      this.stripe.confirmCardPayment(clientSecret, {
        payment_method: { card: card },
        //  setup_future_usage: "off_session",
      })
    );
  }

  payWithId(paymentMethodId, clientSecret) {
    return from(
      this.stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethodId,
      })
    );
  }

  getPaymentMethods() {
    return this.restApiService.get(ServerType.STRIPE, "credit-cards");
  }
}
